module.exports = ".mat-column-lastModifiedDate{flex:0 180px;font-size:0.8em}\n"